// This is generated.  Alter it in blockGroups/formElements/types/FilePicker.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { id, title, propertyName, allowMultiple, required } = hNode;

    // This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    // Determine required/optional/editable flags based on the block configuration
    const { isRequired, isEditable, isOptional } =
      moduleRegistration.resolveFieldFlags(required, context);
    const optional = isOptional;
    const editable = isEditable;

    // Helper to wrap a schema as optional if needed
    const maybeOptional = (schema) =>
      optional ? Type.Optional(schema) : schema;

    // Build the file object schema with name, size, and type properties
    const fileObjectSchema = Type.Object(
      {
        name: Type.String({
          title: 'File Name',
          'x-propertyName': 'name',
          'x-dataType': 'string',
          'x-optional': !!optional,
          'x-editable': !!editable,
        }),
        size: Type.Number({
          title: 'File Size (Bytes)',
          'x-propertyName': 'size',
          'x-dataType': 'number',
          'x-optional': !!optional,
          'x-editable': !!editable,
        }),
        type: Type.String({
          title: 'File Type',
          'x-propertyName': 'type',
          'x-dataType': 'string',
          'x-optional': !!optional,
          'x-editable': !!editable,
        }),
      },
      {
        title: allowMultiple ? 'File' : title,
        'x-dataType': 'object',
        // additionalProperties: true allows extending file objects with extra metadata
        // This enables adding properties like lastModified, content, etc. without breaking validation
        additionalProperties: true,
      },
    );

    // If allowMultiple is true, wrap the file object in an array
    let fileSchema;
    if (allowMultiple) {
      fileSchema = maybeOptional(
        Type.Array(fileObjectSchema, {
          title: title,
          'x-id': id,
          'x-dataType': 'array',
          'x-propertyName': propertyName,
          'x-required': isRequired,
          'x-optional': isOptional,
          'x-editable': isEditable,
        }),
      );
    } else {
      fileSchema = maybeOptional(
        Type.Object(
          {
            name: Type.String({
              title: 'File Name',
              'x-propertyName': 'name',
              'x-dataType': 'string',
              'x-optional': !!optional,
              'x-editable': !!editable,
            }),
            size: Type.Number({
              title: 'File Size (Bytes)',
              'x-propertyName': 'size',
              'x-dataType': 'number',
              'x-optional': !!optional,
              'x-editable': !!editable,
            }),
            type: Type.String({
              title: 'File Type',
              'x-propertyName': 'type',
              'x-dataType': 'string',
              'x-optional': !!optional,
              'x-editable': !!editable,
            }),
          },
          {
            title: title,
            'x-id': id,
            'x-dataType': 'object',
            'x-propertyName': propertyName,
            'x-required': isRequired,
            'x-optional': isOptional,
            'x-editable': isEditable,
            // additionalProperties: true allows extending file objects with extra metadata
            // This enables adding properties like lastModified, content, etc. without breaking validation
            // For example, a file object could be extended with a "content" property containing the file's contents as a base64-encoded string
            additionalProperties: true,
          },
        ),
      );
    }

    // The partial type definition is a plain object with the property schema
    // This maps the propertyName to the generated file schema for validation
    const partialTypeDefinition = {
      [propertyName]: fileSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'FilePicker',
  module.exports,
);
